<form [formGroup]="form" *ngIf="!loading" id="teacher-profile-certificates" class="margin-bottom-2">
  <div class="container-form margin-auto">

    <!-- Certificates -->
    <div formArrayName="certificates" class="margin-bottom-05 margin-top-2">
      <mat-card class="form-group"
        *ngFor="let certificate of certificatesFormArray.controls; let index = index; let last = last; let first = first">
        <div class="mat-h3 font-weight-bold profile-card-title">
          {{'your-education'|translate}}
        </div>
        <div class="flex-end">
          <button mat-icon-button (click)="removeCertificate(index)" [disabled]="certificate.state">
            <mat-icon svgIcon="minus-circle" color="warn"></mat-icon>
          </button>
        </div>

        <div [formGroupName]="index">

          <!-- type -->
          <mat-form-field appearance="legacy">
            <mat-label>{{'your-education'|translate}}</mat-label>
            <input class="form-control" matInput formControlName="type" type="text">
            <mat-error *ngIf="(certificate.controls.type?.invalid && certificate.controls.type?.touched)">
              {{'valid-input'|translate}}
            </mat-error>
          </mat-form-field>

          <!-- issued_by -->
          <mat-form-field appearance="legacy" class="margin-top-1">
            <mat-label>{{'issued_by'|translate}}</mat-label>
            <input class="form-control" matInput formControlName="issued_by">
            <mat-error *ngIf="(certificate.controls.issued_by?.invalid && certificate.controls.issued_by?.touched)">
              {{'valid-input'|translate}}
            </mat-error>
          </mat-form-field>


          <!-- study_years -->
          <mat-form-field appearance="legacy" class="margin-top-1">
            <mat-label>{{'study_years'|translate}}</mat-label>
            <input class="form-control" matInput formControlName="study_years" placeholder="YYYY-YYYY">
            <mat-error *ngIf="(certificate.controls.study_years?.invalid && certificate.controls.study_years?.touched)">
              {{'valid-input'|translate}}
            </mat-error>
          </mat-form-field>

          <!-- document_base64 -->
          <div class="mat-h4 margin-top-1">
            {{'attach-supporting-documentation'|translate}}
          </div>
          <div class="flex-center">
            <mat-icon svgIcon="certificate"
              *ngIf="!(certificate.value.document_base64 || certificate.value.document_path); else certificateTemplate "
              (click)="certificateFile.click()" class="margin-top-1 gallery-icon btn-upload"></mat-icon>
            <input #certificateFile type="file" accept="image/png,image/jpeg,application/pdf,.doc,.docx"
              (change)="onSelectCertificate($event.target,index, certificate.value.id_image)" style="display: none;">

            <ng-template #certificateTemplate>
              <div *ngIf="certificate.value.document; else certificatePathTemplate">
                <div *ngIf="certificate.value.document.type.includes('image/'); else fileTemplate" class="flex-center">
                  <img [id]="'certificate-'+certificate.value.id_image" class="margin-top-1 img-2"
                    (click)="certificateFile.click()" />
                  <!-- <img [id]="'certificate-'+certificate.value.id_image" class="margin-top-1 img-2"
                    [src]="certificate.value.document_path?certificate.value.document_path:''"
                    (click)="certificateFile.click()" /> -->
                </div>
                <ng-template #fileTemplate>
                  <div class="flex-center-column margin-top-1 cursor-pointer" (click)="certificateFile.click()">
                    <mat-icon svgIcon="file" class="file-icon"></mat-icon>
                    <div class="margin-top-05">{{certificate.value.document.name}}</div>
                  </div>
                </ng-template>
              </div>

              <!-- Path case -->
              <ng-template #certificatePathTemplate>
                <div *ngIf="['png','jpeg'].includes(certificate.value.type_doc); else fileTemplate" class="flex-center">
                  <img [id]="'certificate-'+certificate.value.id_image" class="margin-top-1 img-2"
                    [src]="certificate.value.document_path?certificate.value.document_path:''"
                    [matMenuTriggerFor]="menu" />
                  <mat-menu #menu="matMenu" yPosition="above" xPosition="after">
                    <button mat-menu-item (click)="certificateFile.click()"  class="btn-upload">{{'upload'|translate}}</button>
                    <button mat-menu-item
                      (click)="downloadFile(certificate.value.document_path)">{{'download'|translate}}</button>
                  </mat-menu>
                </div>
                <ng-template #fileTemplate>

                  <button mat-button [matMenuTriggerFor]="menu">
                    <div class="flex-center-column margin-top-1 cursor-pointer">
                      <mat-icon svgIcon="file" class="file-icon"></mat-icon>
                      <div class="margin-top-05">{{'certificate'|translate}}</div>
                    </div>
                  </button>
                  <mat-menu #menu="matMenu" yPosition="above" xPosition="after">
                    <button mat-menu-item (click)="certificateFile.click()">{{'upload'|translate}}</button>
                    <button mat-menu-item
                      (click)="downloadFile(certificate.value.document_path)">{{'download'|translate}}</button>
                  </mat-menu>
                </ng-template>
              </ng-template>

            </ng-template>
          </div>
          <div class="mat-caption gray margin-top-05">{{'file-limitator-text-1'|translate}}</div>

        </div>

      </mat-card>
      <div class="flex-center margin-top-1">
        <button type="button" class="btn btn-success" (click)="addCertificate()">
          <div class="flex-center">
            <span class="margin-right-05">{{'add-certificate'|translate}}</span>
            <mat-icon svgIcon="plus"></mat-icon>
          </div>
        </button>
      </div>
    </div>

    <div class="row justify-content-center">
      <!-- Button -->
      <button mat-raised-button color="primary" class="width-50 margin-top-1 margin-bottom-05 padding-05"
        [class.spinner]="sending" (click)="sendForm()" [disabled]="!validateForm">
        <span>{{'save'|translate}}</span>
      </button>
    </div>
  </div>

</form>